import React, { type ReactElement } from 'react';
import { Box, SkeletonLoader } from '@saviynt/design-system';

import './ViolationsTabDetailsMitigatingLoader.css';

/**
 * ViolationsTabDetailsMitigatingLoader
 */
function ViolationsTabDetailsMitigatingLoader(): ReactElement {
  const array = Array.from(Array(3).keys());

  return (
    <Box tag='div' className='Sod-ViolationsTabDetailsMitigate-loaderWrapper'>
      {array.map((ind) => (
        <Box
          key={ind}
          className='Sod-ViolationsTabDetailsMitigateLoader-wrapper'>
          <SkeletonLoader
            shape='square'
            animationStyle='wave'
            width='1.5rem'
            height='1.5rem'
          />
          <SkeletonLoader
            shape='square'
            animationStyle='wave'
            width='1.5rem'
            height='1.5rem'
          />
          <Box
            tag='div'
            className='Sod-ViolationsTabDetailsMitigateLoader-centerContent'>
            <SkeletonLoader
              shape='square'
              animationStyle='wave'
              height='1rem'
              width='75%'
            />
            <SkeletonLoader
              shape='square'
              animationStyle='wave'
              height='2rem'
              width='100%'
            />
          </Box>
          <SkeletonLoader
            shape='square'
            animationStyle='wave'
            height='2.5rem'
            width='7.5rem'
          />
        </Box>
      ))}
    </Box>
  );
}

export default ViolationsTabDetailsMitigatingLoader;
